import {
    DotsHorizontalIcon
} from '@radix-ui/react-icons';
import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";
import { useContext, useState } from 'react';
import '../../App.css';
import { AuthContext } from '../../context/AuthContext';
import sport_classes from '../../enums/sport_classes.json';
import AddCertificationDialog from '../dialogs/addCertificateDialog';
import RemoveCertificateDialog from '../dialogs/removeCertificateDialog';
import { Button } from '../ui/button';
import {
    Dialog,
} from "../ui/dialog";
import {
    DropdownMenu,
    DropdownMenuContent, DropdownMenuLabel, DropdownMenuTrigger
} from "../ui/dropdown-menu";
import { DataTable } from './datatable';
import DatatableSortButton from './datatableSortButton';

export const columns = (fetchQualifications, getSportClassNameById, auth, dataLength) => {
    const isAdminOrPrivilegedUser = auth?.user?.superadmin || auth?.user?.bunnyadmin;

    const baseColumns = [
        {
            accessorKey: "sport_class_id",
            header: ({ column }) => <DatatableSortButton column={column}>Klass</DatatableSortButton>,
            cell: info => {
                const sportClassId = info.row.original.sport_class_id;
                return getSportClassNameById(sportClassId); // Display both parts of the sport class name
            }
        },
        {
            accessorKey: "acquired_at",
            header: ({ column }) => <DatatableSortButton column={column}>Datum</DatatableSortButton>,
            cell: info => {
                const certificate = info.row.original;
                const date = new Date(certificate.acquired_at);
                return date.toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
            }
        },
        {
            accessorKey: "region",
            header: ({ column }) => <DatatableSortButton column={column}>Region</DatatableSortButton>,
        },
        {
            accessorKey: "free",
            header: ({ column }) => <DatatableSortButton column={column}>Fricert</DatatableSortButton>,
            cell: info => {
                const certificate = info.row.original;
                return certificate.free ? "Ja" : "Nej";
            }
        },
    ];

    if (isAdminOrPrivilegedUser && dataLength > 0) {
        baseColumns.push({
            id: "actions",
            enableHiding: false,
            cell: ({ row }) => {
                const certificate = row.original;
                return (
                    <Dialog modal={true}>
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button variant="ghost" className="h-8 w-8 p-0 float-right">
                                    <span className="sr-only">Öppna meny</span>
                                    <DotsHorizontalIcon className="h-4 w-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end" onCloseAutoFocus={(e) => {
                                e.preventDefault();
                            }}>
                                <DropdownMenuLabel>Alternativ</DropdownMenuLabel>
                                <RemoveCertificateDialog certificate={certificate} fetchQualifications={fetchQualifications} />
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </Dialog>
                );
            }
        });
    }

    return baseColumns;
};


export function CertificateDatatable({ bunny, certificates, fetchQualifications, isLoading, reloadBunnySinglePage }) {
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);
    const { auth } = useContext(AuthContext);

    const getSportClassNameById = (id) => {
        const sportClass = sport_classes.find((sport_class) => sport_class.id === id);
        return sportClass ? sportClass.sport_class_name : "Okänd klass"; // Fallback if ID is not found
    };

    const table = useReactTable({
        data: certificates, // Ensure data is always an array
        columns: columns(fetchQualifications, getSportClassNameById, auth, certificates.length),
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting,
            columnFilters,
        },
    });

    return (
        <div className='rounded-md bg-gray-100 p-3'>
            <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3 py-3 items-center'>
                <h2 className='font-medium text-lg'>Certifikat</h2>
                {(auth.user?.superadmin || auth.user?.bunnyadmin || auth.user?.judge) && (
                    <div className='grid grid-cols-2 xl:col-start-3 gap-3'>
                        <div></div>
                        <AddCertificationDialog fetchQualifications={fetchQualifications} bunny={bunny} reloadBunnySinglePage={reloadBunnySinglePage} />
                    </div>
                )}
            </div>
            <DataTable
                table={table}
                isLoading={isLoading}
                columns={columns(fetchQualifications, auth)}
            />
        </div>
    );
}
